import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { PriceRules, CreatePriceRule, UpdatePriceRule } from "./pages";

export const PriceRulesRouter = [
  <Route
    path="/price-rules"
    element={
      <ProtectedRoute roles={["Any"]}>
        <PriceRules />
      </ProtectedRoute>
    }
  />,

  <Route path="/price-rule">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreatePriceRule />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdatePriceRule />
        </ProtectedRoute>
      }
    />
  </Route>,
];
